/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { apiClient } from './client.js';
import { type SessionStatus } from './sessions.js';

export interface TimesheetRow {
  readonly sessionId: string;
  readonly date: string;
  readonly clientName: string;
  readonly sessionType: string | null;
  readonly durationMin: number;
  readonly status: SessionStatus;
  readonly payPct: number;
  readonly amountPaise: number;
}

export interface Timesheet {
  readonly rows: readonly TimesheetRow[];
  readonly totalSessions: number;
  readonly totalHours: number;
  readonly totalAmountPaise: number;
  readonly ratePaise: number | null;
}

export interface TimesheetRange {
  readonly from?: string | undefined;
  readonly to?: string | undefined;
}

export const timesheetApi = {
  async mine(range: TimesheetRange): Promise<Timesheet> {
    const { data } = await apiClient.get<Timesheet>('/timesheet/mine', { params: range });
    return data;
  },
  async forTherapist(therapistId: string, range: TimesheetRange): Promise<Timesheet> {
    const { data } = await apiClient.get<Timesheet>(`/timesheet/therapist/${therapistId}`, {
      params: range,
    });
    return data;
  },
};
